<div class="widget__header widget-filters__header">
    <h4>{{ 'HEADER_FILTERS'|translate }}</h4>
</div>

<div class="widget-filters__list" [formGroup]="filterForm">
    <div class="widget-filters__item">
        <div class="filter filter--opened" appCollapseItem="filter--opened" #collapseItem="appCollapseItem">
            <button type="button" class="filter__title" (click)="collapseItem.toggle()">
                Category
                <span class="filter__arrow"><app-icon icon="arrow-rounded-down-12x7"></app-icon></span>
            </button>
            <div class="filter__body" appCollapseContent>
                <div class="filter__container" style="height: 250px; overflow: scroll;">
                    <input type="text" (keyup)="search('category', $event)" placeholder="Search" class="form-control" style="height: 24px;">
                    <div style="padding-top: 20px;"></div>

                        <app-filter-radio [options]="category" [name]="name.category" formControlName="category_id"></app-filter-radio>
                </div>
            </div>
        </div>
    </div>
    <div  class="widget-filters__item">
        <div class="filter filter--opened" appCollapseItem="filter--opened" #collapseItem2="appCollapseItem">
            <button type="button" class="filter__title" (click)="collapseItem2.toggle()">
                Sub Category
                <span class="filter__arrow"><app-icon icon="arrow-rounded-down-12x7"></app-icon></span>
            </button>
            <div class="filter__body" appCollapseContent>
                <div class="filter__container" style="height: 250px; overflow: scroll;">
                    <input type="text" (keyup)="search('sub_category', $event)" placeholder="Search" class="form-control" style="height: 24px;">
                    <div style="padding-top: 20px;"></div>

                        <app-filter-radio [options]="subCategory" [name]="name.sub_category" formControlName="subcategory_id"></app-filter-radio>

                </div>
            </div>
        </div>
    </div>
    <div class="widget-filters__item">
        <div class="filter filter--opened" appCollapseItem="filter--opened" #collapseItem5="appCollapseItem">
            <button type="button" class="filter__title" (click)="collapseItem5.toggle()">
                Affiliation
                <span class="filter__arrow"><app-icon icon="arrow-rounded-down-12x7"></app-icon></span>
            </button>
            <div class="filter__body" appCollapseContent>
                <div class="filter__container" style="height: 250px; overflow: scroll;">
                    <input type="text" (keyup)="search('affiliation', $event)" placeholder="Search" class="form-control" style="height: 24px;">
                    <div style="padding-top: 20px;"></div>

                        <app-filter-radio [options]="affiliation" [name]="name.affiliation" formControlName="affiliation_id"></app-filter-radio>
                </div>
            </div>
        </div>
    </div>
    <div  class="widget-filters__item">
        <div class="filter filter--opened" appCollapseItem="filter--opened" #collapseItem3="appCollapseItem">
            <button type="button" class="filter__title" (click)="collapseItem3.toggle()">
                State
                <span class="filter__arrow"><app-icon icon="arrow-rounded-down-12x7"></app-icon></span>
            </button>
            <div class="filter__body" appCollapseContent>
                <div class="filter__container" style="height: 250px; overflow: scroll;">

                    <input type="text" (keyup)="search('state', $event)" placeholder="Search" class="form-control" style="height: 24px;">
                    <div style="padding-top: 20px;"></div>
                        <app-filter-radio [options]="state" [name]="name.state" formControlName="state_id"></app-filter-radio>

                </div>
            </div>
        </div>
    </div>
    <div  class="widget-filters__item">
        <div class="filter filter--opened" appCollapseItem="filter--opened" #collapseItem4="appCollapseItem">
            <button type="button" class="filter__title" (click)="collapseItem4.toggle()">
                City
                <span class="filter__arrow"><app-icon icon="arrow-rounded-down-12x7"></app-icon></span>
            </button>
            <div class="filter__body" appCollapseContent>
                <div class="filter__container" style="height: 250px; overflow: scroll;">
                    <input type="text" (keyup)="search('city', $event)" placeholder="Search" class="form-control" style="height: 24px;">
                    <div style="padding-top: 20px;"></div>

                        <app-filter-radio [options]="city" [name]="name.city" formControlName="city_id"></app-filter-radio>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="widget-filters__actions d-flex">
    <button class="btn btn-secondary btn-sm" (click)="resetFilter()">{{ 'BUTTON_RESET'|translate }}</button>
</div>
